export default __webpack_public_path__ + "static/media/LibreFranklin-Bold.be70c539.ttf";